import HttpCliente from '../HttpCliente';

/**
 * GET method - Obtiene la lista de usuarios
 * @param {Function} setUsers función para establecer la lista de usuarios
 * @param {Function} setError función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const getUsers = (setUsers, setError) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/Usuario", {
            headers: {
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setUsers(response.data); // Establece la lista de usuarios en el estado
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

/**
 * POST method - Registra un nuevo usuario
 * @param {Object} newUser - Objeto que contiene los datos del usuario a registrar
 * @param {Function} setRegisterError - Función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const createUser = (newUser, setRegisterError) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post("/Usuario", newUser, {
            headers: {
                'accept': '*/*',
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.status === 201) {
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setRegisterError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setRegisterError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setRegisterError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

/**
 * PUT method - Actualiza un usuario existente
 * @param {string} userId - ID del usuario a actualizar
 * @param {Object} updatedUser - Objeto que contiene los datos actualizados del usuario
 * @param {Function} setUpdateError - Función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const updateUser = (userId, updatedUser, setUpdateError) => {
    return new Promise((resolve, reject) => {
        HttpCliente.put(`/Usuario/${userId}`, updatedUser, {
            headers: {
                'accept': '*/*',
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.status === 204) {
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setUpdateError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setUpdateError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setUpdateError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

/**
 * GET method - Obtiene la lista de usuarios con paginación
 * @param {Function} setUsers función para establecer la lista de usuarios
 * @param {Function} setError función para establecer el estado de error
 * @param {Number} page número de página
 * @param {Number} pageSize tamaño de página
 * @param {String} searchTerm término de búsqueda
 * @return {Promise} Promesa de obtención
 */
export const getUsersPaginados = (setUsers, setError, page = 1, pageSize = 5, searchTerm = '', token) => {
    return new Promise((resolve, reject) => {
        let url = `/Usuario?pageNumber=${page}&pageSize=${pageSize}`;
        if (searchTerm) {
            url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
        }
        
        HttpCliente.get(url, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                console.log(response)
                setUsers(response.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message);
                reject(error.response.data.message);
            } else {
                setError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};

/**
 * POST method - Registra un nuevo usuario
 * @param {Object} newUser - Objeto que contiene los datos del usuario a registrar
 * @param {Function} setRegisterError - Función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const createUserByAdmin = (newUser, setRegisterError) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post("/Usuario/crear-usuario-admin", newUser, {
            headers: {
                'accept': '*/*',
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.status === 201) {
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setRegisterError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setRegisterError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setRegisterError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

/**
 * GET method - Obtiene los roles disponibles
 * @param {Function} setRoles - Función para establecer la lista de roles
 * @param {Function} setError - Función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const getRolesDisponibles = (setRoles, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/Usuario/roles-disponibles", {
            headers: {
                'Authorization': `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setRoles(response.data.data);
                resolve(response.data.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message);
                reject(error.response.data.message);
            } else {
                setError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};

/**
 * POST method - Crea un usuario con rol específico
 * @param {Object} newUser - Objeto que contiene los datos del usuario a registrar
 * @param {String} rolId - ID del rol a asignar
 * @param {Function} setRegisterError - Función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const createUserWithRole = (newUser, rolId, setRegisterError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post(`/Usuario/crear-usuario-con-rol?rolId=${rolId}`, newUser, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'accept': '*/*',
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.status === 201) {
                resolve(response.data);
            } else {
                setRegisterError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setRegisterError(error.response.data.message);
                reject(error.response.data.message);
            } else {
                setRegisterError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};

/**
 * PUT method - Actualiza un usuario con rol específico
 * @param {String} userId - ID del usuario a actualizar
 * @param {Object} updatedUser - Objeto que contiene los datos actualizados del usuario
 * @param {String} rolId - ID del rol a asignar
 * @param {Function} setUpdateError - Función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const updateUserWithRole = (userId, updatedUser, rolId, setUpdateError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.put(`/Usuario/editar-usuario-con-rol/${userId}?rolId=${rolId}`, updatedUser, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'accept': '*/*',
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.status === 204) {
                resolve(response.data);
            } else {
                setUpdateError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setUpdateError(error.response.data.message);
                reject(error.response.data.message);
            } else {
                setUpdateError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};


/**
 * GET method - Obtiene la lista de usuarios sin comediante asociado con paginación
 * @param {Function} setUsers función para establecer la lista de usuarios
 * @param {Function} setError función para establecer el estado de error
 * @param {Number} page número de página
 * @param {Number} pageSize tamaño de página
 * @param {String} searchTerm término de búsqueda
 * @return {Promise} Promesa de obtención
 */
export const getUsersSinComediante = (setUsers, setError, page = 1, pageSize = 10, searchTerm = '', token) => {
    return new Promise((resolve, reject) => {
        let url = `/Usuario/sin-comediante?pageNumber=${page}&pageSize=${pageSize}`;
        if (searchTerm) {
            url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
        }
        
        HttpCliente.get(url, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                console.log('Usuarios sin comediante:', response);
                setUsers(response.data);
                resolve(response.data);
            } else if (response.status === 204) {
                // No hay usuarios sin comediante, lista vacía (no es error)
                console.log('No hay usuarios sin comediante disponibles.');
                setUsers([]);
                resolve([]);
            } else {
                setError(response.data?.message || 'Error desconocido');
                reject(response.data?.message || 'Error desconocido');
            }
        })

        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message);
                reject(error.response.data.message);
            } else {
                setError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};